var _excluded = ["isDisabled", "secondarySelectedDate", "selectedDate", "onSelect", "minDate", "maxDate", "excludeHolidays", "weekDays", "legendItems", "showToday", "footer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Card, Group } from '../../../containers';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Divider } from '../../dataDisplay/Divider';
import { _BaseCalendar, Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Calendar = forwardRef((_ref, ref) => {
  var {
    isDisabled,
    secondarySelectedDate,
    selectedDate,
    onSelect,
    minDate,
    maxDate,
    excludeHolidays,
    weekDays,
    legendItems,
    showToday,
    footer
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('Calendar');
  return /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({
    width: "min-content",
    paddingX: "none",
    paddingY: "none",
    "data-component": "Calendar"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "none",
      children: [/*#__PURE__*/_jsx(Box, {
        __css: styles,
        children: /*#__PURE__*/_jsx(_BaseCalendar, {
          ref: ref,
          isDisabled: isDisabled,
          secondarySelectedDate: secondarySelectedDate,
          selectedDate: selectedDate,
          onSelect: onSelect,
          minDate: minDate,
          maxDate: maxDate,
          excludeHolidays: excludeHolidays,
          weekDays: weekDays,
          legendItems: legendItems,
          showToday: showToday,
          size: "large"
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Box, {
        children: footer
      })]
    })
  }));
});
Calendar.displayName = 'Calendar';
//# sourceMappingURL=Calendar.js.map